import { z } from "zod"

import { intervalSchema } from "./interval"

export const intervalInfoSchema = z.object({
  fromDateTime: z.string(),
  toDateTime: z.string(),
  duration: z.number(),
  kWh: intervalSchema,
  kW: intervalSchema,
  total: intervalSchema.optional(),
})

export type IntervalInfo = z.infer<typeof intervalInfoSchema>
